// Spatial hash for 2D / 3D points. Each coordinate is snapped to a
// TOL-sized grid cell, multiplied by a distinct large prime per
// axis, and the per-axis values are XOR'd into a single integer.
// Returns a 32-bit number — cell collisions are possible but
// vanishingly rare at typical per-house scales.
//
// Technique from Teschner et al. 2003, "Optimized Spatial Hashing
// for Collision Detection of Deformable Objects":
// https://matthias-research.github.io/pages/publications/tetraederCollision.pdf

const P1 = 73856093;
const P2 = 19349663;
const P3 = 83492791;

const TOL = 0.01;
const EPSILON = 1 / TOL;

function discretize(n: number): number {
  return Math.round((n + Number.EPSILON) * EPSILON) / EPSILON;
}

export function hashVec2(x: number, y: number): number {
  return (discretize(x) * P1) ^ (discretize(y) * P2);
}

export function hashVec3(x: number, y: number, z: number): number {
  return (discretize(x) * P1) ^ (discretize(y) * P2) ^ (discretize(z) * P3);
}
